<template>
    <b-container>
    <h1>Active User Summary</h1>
    <div v-if="results.length > 0">
    <b-table striped hover :items="results">
        <template #cell(date_created)="data">
            {{ data.value | fullDate }}
        </template>
        <template #cell(date_updated)="data">
            {{ data.value | fullDate }}
        </template>
    </b-table>
    </div>
    <div v-else align="center">
    <b-alert variant="secondary" show>
        <strong>Loading...</strong>
    </b-alert>
    </div>
</b-container>
</template>

<script>
import ReportDataService from '@/services/ReportDataService';

export default {
    data() {
        return {
            results: []
        }
    },
    created() {

        ReportDataService.getUserSummary().then((res) => {
            this.results = res.data;
        })
    }
}
</script>